package com.anjuros.website.templates.template8.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.template8.util.Template8Constants.FONT_FAMILY
import com.anjuros.website.templates.template8.modules.Template8WhatsOn
import com.anjuros.website.templates.template8.styles.Template8Theme
import com.anjuros.website.templates.template8.styles.Template8WhatsOnCardStyle
import com.anjuros.website.templates.template8.styles.getColor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translate
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template8WhatsOnCard(
    template8WhatsOn: Template8WhatsOn,
    animatedTranslateX: CSSSizeValue<CSSUnit.percent>,
    animatedTranslateY: CSSSizeValue<CSSUnit.percent>
){
    Box(modifier = Template8WhatsOnCardStyle
        .toModifier()
        .translate(  tx = animatedTranslateX,
            ty = animatedTranslateY)
        .transition(
            Transition.of("translate", 1000.ms))
        .border(
            width = 2.px,
            color = Template8Theme.Primary.getColor(),
            style = LineStyle.Solid

        )
        .backgroundColor(Colors.White)
        .boxShadow(
            4.px, 4.px, 10.0.px, 2.0.px, color = Theme.DarkGrey.rgb, false
        )
        ){


        Column(
            modifier = Modifier.fillMaxWidth()
                .id("cardColumn")
                .padding(topBottom = 15.px, leftRight = 4.px),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            P(
                attrs = Modifier
                    .fontFamily(FONT_FAMILY)
                    .textAlign(TextAlign.Center)
                    .fontSize(24.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Template8Theme.Primary.getColor())
                    .toAttrs()
            ) {

                Text(LocalText(template8WhatsOn.title))

            }
            AnjurosImage(
                modifier = Modifier
                    .id("whatsonImage")
                    .margin(bottom = 20.px)
                    .size(64.px)
                    .objectFit(ObjectFit.ScaleDown),
                src = template8WhatsOn.image,
                alt = "Pub menu"
            )
            template8WhatsOn.description.forEach { desc ->
                P(
                    attrs = Modifier
                        .textAlign(TextAlign.Center)
                        .margin(topBottom = 0.px)
                        .fontFamily(FONT_FAMILY)
                        .fontSize(18.px)
                        .fontWeight(FontWeight.Normal)
                        .color(Template8Theme.DarkGrey.rgb)
                        .toAttrs()
                ) {
                    Text(LocalText(desc))

                }

            }
        }
    }
}